import { administratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { fixturePageConfig } from "./fixturePageConfig";
import {
  fixtureBehaviours,
  fixtureOptionFilters,
  fixtureValidators,
} from "./fixtureRules";
import {
  fixtureReadinessRowActions,
  readReadinessRows,
} from "./fixtureReadinessActions";

export const fixtureRecordDefinition: RecordDefinition = {
  path: "/fixture",
  entityName: "dwfixture",
  listRoute: "/fixtures",
  backTitle: "Back to fixtures",
  allowedRoles: administratorRoles,
  config: fixturePageConfig,
  // The warehouse holds this record, and the view resolver never sees it.
  authorable: false,
  identity: {
    titleFields: ["name"],
    fallbackTitle: "Fixture",
    newRecordTitle: "New Fixture",
  },
  fieldBehaviours: fixtureBehaviours,
  fieldValidators: fixtureValidators,
  lookupOptionFilters: fixtureOptionFilters,
  relatedTableActions: {
    fixtureautomationreadiness: {
      rowActions: fixtureReadinessRowActions,
      refresh: ({ globalDispatch, parentId }) =>
        readReadinessRows(globalDispatch, parentId),
    },
  },
};
